// Bilingual dictionary for KAFKAZSTYLE
export const translations = {
  en: {
    nav: {
      collection: "Collection",
      heritage: "Heritage",
      lookbook: "Lookbook",
      journal: "Journal",
      contact: "Contact",
    },
    hero: {
      overline: "Est. Caucasus — Heritage Atelier",
      title_l1: "Where the mountains",
      title_l2: "wear couture.",
      sub: "A study of Caucasian craftsmanship — wool, leather, and silver, recut for a modern silhouette.",
      cta_primary: "Explore Collection",
      cta_secondary: "Our Heritage",
    },
    marquee: "Heritage Reimagined • Традиции и Современность • Hand-finished in the Caucasus • Couture from the Mountains • ",
    featured: {
      overline: "Volume 01 — Winter",
      title: "The Featured Collection",
      sub: "Six pieces shaping the silhouette of this season. Cuts informed by chokha tailoring, dyed in earth-pulled pigments.",
      view_all: "View Full Atelier",
      items: [
        { tag: "Outerwear", name: "Aslan Wool Coat", price: "€1,290" },
        { tag: "Tailoring",  name: "Tbilisi Chokha Jacket", price: "€980" },
        { tag: "Knitwear",   name: "Daghestan Cable Sweater", price: "€420" },
      ],
    },
    about: {
      overline: "Our Heritage",
      title_l1: "Born of stone,",
      title_l2: "raised by wool.",
      p1: "KAFKAZSTYLE is a quiet rebellion against the disposable. Each garment is shaped by hands that have known the mountain — by artisans in Tbilisi, Vladikavkaz, and Baku whose mothers and grandmothers spun the same yarns.",
      p2: "We do not chase trends. We translate centuries-old silhouettes — the chokha, the burka, the papakh — into a vocabulary that lives quietly in modern wardrobes.",
      stat1_label: "Atelier founded",
      stat1_value: "2019",
      stat2_label: "Artisans",
      stat2_value: "37",
      stat3_label: "Pieces per year",
      stat3_value: "< 800",
    },
    lookbook: {
      overline: "Lookbook — Winter Edition",
      title: "Cold rooms, warm cloth.",
      sub: "An editorial study in shadow and texture, photographed in the foothills of Kazbek.",
    },
    newsletter: {
      overline: "Dispatches",
      title_l1: "Receive our",
      title_l2: "private editions.",
      sub: "Letters from the atelier — collection previews, artisan stories, no noise.",
      placeholder: "your.email@domain.com",
      submit: "Subscribe",
      success: "Welcome to the atelier.",
      error: "Please enter a valid email.",
    },
    contact: {
      overline: "Correspondence",
      title: "Write to the atelier.",
      sub: "For private orders, press, or simply to say hello — we read every letter.",
      name: "Full name",
      email: "Email address",
      message: "Your message",
      submit: "Send Letter",
      success: "Your letter is on its way.",
      error: "Something is amiss. Please try again.",
    },
    footer: {
      tagline: "Heritage Couture from the Caucasus.",
      sections: {
        atelier: "Atelier",
        atelier_links: ["About", "Journal", "Sustainability"],
        shop: "Shop",
        shop_links: ["Outerwear", "Knitwear", "Accessories"],
        contact: "Contact",
        contact_links: ["press@kafkazstyle.co", "+995 32 220 11 11", "Tbilisi · Georgia"],
      },
      bottom: "© 2026 KAFKAZSTYLE — All rights reserved.",
    },
  },
  ru: {
    nav: {
      collection: "Коллекция",
      heritage: "Наследие",
      lookbook: "Лукбук",
      journal: "Журнал",
      contact: "Контакты",
    },
    hero: {
      overline: "Кавказ — Дом Высокого Ремесла",
      title_l1: "Когда горы",
      title_l2: "носят кутюр.",
      sub: "Исследование кавказского ремесла — шерсть, кожа, серебро, переосмысленные в современном силуэте.",
      cta_primary: "Смотреть Коллекцию",
      cta_secondary: "Наше Наследие",
    },
    marquee: "Heritage Reimagined • Традиции и Современность • Ручная работа на Кавказе • Кутюр с гор • ",
    featured: {
      overline: "Том 01 — Зима",
      title: "Главная Коллекция",
      sub: "Шесть силуэтов сезона. Крой, вдохновлённый чохой, окрашенный пигментами земли.",
      view_all: "Посмотреть Все Изделия",
      items: [
        { tag: "Верхняя одежда", name: "Шерстяное пальто «Аслан»", price: "€1,290" },
        { tag: "Костюмы",         name: "Жакет-чоха «Тбилиси»",     price: "€980" },
        { tag: "Трикотаж",        name: "Свитер «Дагестан»",         price: "€420" },
      ],
    },
    about: {
      overline: "Наше Наследие",
      title_l1: "Рождённые камнем,",
      title_l2: "взращённые шерстью.",
      p1: "KAFKAZSTYLE — тихий протест против одноразового. Каждая вещь сшита руками тех, кто знает гору — мастеров Тбилиси, Владикавказа и Баку, чьи матери пряли ту же шерсть.",
      p2: "Мы не следуем трендам. Мы переводим вековые силуэты — чоху, бурку, папаху — на язык современного гардероба.",
      stat1_label: "Основано",
      stat1_value: "2019",
      stat2_label: "Мастеров",
      stat2_value: "37",
      stat3_label: "Изделий в год",
      stat3_value: "< 800",
    },
    lookbook: {
      overline: "Лукбук — Зимний Выпуск",
      title: "Холодные залы, тёплая ткань.",
      sub: "Редакционное исследование света и текстуры, снятое в предгорьях Казбека.",
    },
    newsletter: {
      overline: "Рассылка",
      title_l1: "Получайте наши",
      title_l2: "закрытые издания.",
      sub: "Письма из ателье — превью коллекций, истории мастеров, без шума.",
      placeholder: "ваш.email@domen.com",
      submit: "Подписаться",
      success: "Добро пожаловать в ателье.",
      error: "Введите корректный email.",
    },
    contact: {
      overline: "Переписка",
      title: "Напишите в ателье.",
      sub: "Для частных заказов, прессы или просто поздороваться — мы читаем каждое письмо.",
      name: "Полное имя",
      email: "Электронная почта",
      message: "Ваше сообщение",
      submit: "Отправить Письмо",
      success: "Ваше письмо в пути.",
      error: "Что-то пошло не так. Попробуйте снова.",
    },
    footer: {
      tagline: "Кавказское наследие. Современный кутюр.",
      sections: {
        atelier: "Ателье",
        atelier_links: ["О нас", "Журнал", "Устойчивость"],
        shop: "Магазин",
        shop_links: ["Верхняя одежда", "Трикотаж", "Аксессуары"],
        contact: "Контакты",
        contact_links: ["press@kafkazstyle.co", "+995 32 220 11 11", "Тбилиси · Грузия"],
      },
      bottom: "© 2026 KAFKAZSTYLE — Все права защищены.",
    },
  },
};

export const getT = (lang) => translations[lang] || translations.en;
